//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tinymce from '@/components/Tinymce/index';
import * as categoryApi from '@/api/categoryApi.js';
import * as articleApi from '@/api/article.js';
import { getToken } from '@/utils/auth';
import { Debounce } from '@/utils/validate';
export default {
  // name: "edit",
  components: {
    Tinymce: Tinymce
  },
  props: {
    dialogEditData: {
      default: null,
      type: Object
    },
    isDialogEdit: {
      default: null,
      type: Number
    }
  },
  data: function data() {
    return {
      loading: false,
      constants: this.$constants,
      categoryTreeData: [],
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        expandTrigger: 'hover',
        checkStrictly: true,
        emitPath: false
      },
      pram: {
        author: null,
        cid: null,
        content: '',
        //<span>My Document\'s Title</span>
        imageInput: '',
        isBanner: false,
        isHot: null,
        shareSynopsis: null,
        shareTitle: null,
        sort: 0,
        synopsis: null,
        title: null,
        url: null,
        id: null
        // mediaId: null
      },
      editData: {},
      myHeaders: {
        'X-Token': getToken()
      },
      editorContentLaebl: ""
      // basicForm:{editorContent:""}
    };
  },
  created: function created() {
    var _this2 = this;
    if (this.dialogEditData) {
      categoryApi.articleInfoApi({
        id: this.dialogEditData.id
      }).then(function (data) {
        _this2.editData = data;
        _this2.hadlerInitEditData();
      });
    }
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.getInfo();
      this.setTagsViewTitle();
    }
    this.handlerGetCategoryTreeData();
  },
  methods: {
    getInfo: function getInfo() {
      var _this3 = this;
      categoryApi.articleInfoApi({
        id: this.$route.params.id
      }).then(function (data) {
        _this3.editData = data;
        _this3.hadlerInitEditData();
      });
    },
    modalPicTap: function modalPicTap(tit) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.pram.imageInput = img[0].thumbnailPath;
      }, tit, 'content');
    },
    hadlerInitEditData: function hadlerInitEditData() {
      if (!this.$route.params.id && this.editData == null) return;
      var _this$editData = this.editData,
        author = _this$editData.author,
        cid = _this$editData.cid,
        content = _this$editData.content,
        imageInput = _this$editData.imageInput,
        isBanner = _this$editData.isBanner,
        isHot = _this$editData.isHot,
        shareSynopsis = _this$editData.shareSynopsis,
        shareTitle = _this$editData.shareTitle,
        sort = _this$editData.sort,
        synopsis = _this$editData.synopsis,
        title = _this$editData.title,
        url = _this$editData.url,
        id = _this$editData.id;
      this.pram.author = author;
      this.pram.cid = Number.parseInt(cid);
      this.pram.content = content;
      this.pram.imageInput = imageInput;
      this.pram.isBanner = isBanner;
      this.pram.isHot = isHot;
      this.pram.shareSynopsis = shareSynopsis;
      this.pram.shareTitle = shareTitle;
      this.pram.sort = sort;
      this.pram.synopsis = synopsis;
      this.pram.title = title;
      this.pram.url = url;
      this.pram.id = id;
      // this.pram.mediaId = mediaId
    },
    handlerGetCategoryTreeData: function handlerGetCategoryTreeData() {
      var _this4 = this;
      categoryApi.listCategroy({
        type: 3,
        status: ''
      }).then(function (data) {
        _this4.categoryTreeData = data.recordList;
        localStorage.setItem('articleClass', JSON.stringify(data.recordList));
      });
    },
    handerSubmit: Debounce(function (form) {
      var _this5 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        if (_this5.isDialogEdit) {
          //修改
          if (_this5.isDialogEdit == 1) {
            _this5.handlerUpdate();
          } else {
            _this5.handlerSave();
          }
        } else {
          if (!_this5.$route.params.id) {
            _this5.handlerSave();
          } else {
            _this5.handlerUpdate();
          }
        }
      });
    }),
    handlerUpdate: function handlerUpdate() {
      var _this6 = this;
      this.loading = true;
      this.pram.cid = Array.isArray(this.pram.cid) ? this.pram.cid[0] : this.pram.cid;
      this.pram.shareTitle = this.pram.title;
      this.pram.shareSynopsis = this.pram.synopsis;
      articleApi.UpdateArticle(this.pram).then(function (data) {
        _this6.$message.success('编辑文章成功');
        _this6.loading = false;
        if (_this6.isDialogEdit) {
          _this6.$emit('refresh');
        } else {
          _this6.$store.dispatch("tagsView/delView", _this6.$route);
          _this6.$router.push({
            path: '/content/articleManager'
          });
        }
      }).catch(function () {
        _this6.loading = false;
      });
    },
    handlerSave: function handlerSave() {
      var _this7 = this;
      this.loading = true;
      this.pram.cid = Array.isArray(this.pram.cid) ? this.pram.cid[0] : this.pram.cid;
      this.pram.shareTitle = this.pram.title;
      this.pram.shareSynopsis = this.pram.synopsis;
      articleApi.AddArticle(this.pram).then(function (data) {
        _this7.$message.success('新增文章成功');
        _this7.loading = false;
        if (_this7.isDialogEdit) {
          _this7.$emit('refresh');
        } else {
          _this7.$router.push({
            path: '/content/articleManager'
          });
        }
      }).catch(function () {
        _this7.loading = false;
      });
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = '编辑文章';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    }
  }
};